import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/state/authStore';

interface Props {
  admin?: boolean;
  feedbacker?: boolean;
}

export function RequireRole({ admin, feedbacker }: Props) {
  const user = useAuthStore((s) => s.currentUser);

  if (!user) return <Navigate to="/login" replace />;

  if (admin && !user.is_admin) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600">403 Forbidden</h2>
          <p className="mt-2 text-gray-500">この画面は管理者のみがアクセスできます。</p>
        </div>
      </div>
    );
  }

  if (feedbacker && !user.is_feedbacker) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600">403 Forbidden</h2>
          <p className="mt-2 text-gray-500">
            この画面はフィードバッカー権限を持つユーザーのみがアクセスできます。
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
